import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import { ParsedErrorResponse } from 'types/fetch';

export function getOrchestratorOTPErrors(response: ParsedErrorResponse<OrchestratorErrorResponse>) {
  const { message } = response.errorObject;

  if (message === 'code_invalid') {
    return 'CODE_INVALID';
  }

  if (message === 'code_expired') {
    return 'CODE_EXPIRED';
  }

  return null;
}
